import React, { useEffect, useState } from "react";
import "./ItemInfoModal.css";
import { Modal } from "@mui/material";

import { arrowLeftWhite } from "../../../../Assets/svgs";
import { formatDateTime } from "../../../../Utils/TimeConverter";

interface InfoModalInterface {
  children: React.ReactElement;
  image: string;
  title: string;
  description: string;
  isVisible: boolean;
  currentItemId: number;
  onClose: () => void;
  cbHandleCloseItemInfo: () => void;
  cbAddRecommended: (currentItemId: number) => void;
  examDate: string;
}

const ItemInfoModal = (props: InfoModalInterface) => {
  console.log(props);
  useEffect(() => {
    const handleBeforeUnload = () => {
      props.cbHandleCloseItemInfo();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      props.cbHandleCloseItemInfo();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <Modal
      style={{
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
      }}
      open={props.isVisible}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="item-info-wrap">
        <button
          className="item-info-back-button"
          onClick={props.cbHandleCloseItemInfo}
        >
          <img
            style={{
              top: "-5px",
            }}
            src={arrowLeftWhite}
            alt="&lt;-"
          />
          Go back
        </button>
        <br />
        <div className="item-info-container">
          <img className="item-info-image" alt="info-image" src={props.image} />
          <div className="item-info-title">{props.title}</div>
          <div className="item-info-desc">
            The National Finance Olympiad is a competitive exam focused on
            building financial literacy among students across India.
          </div>

          {/* Cards Section */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              marginTop: "20px",
              width: "100%",
            }}
          >
            {/* Card 1: Registration */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "12px 16px",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
                border: "1px solid rgba(36, 108, 193, 0.1)",
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "rgba(36, 108, 193, 0.1)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                    stroke="#246CC1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 2V8H20"
                    stroke="#246CC1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16 13H8"
                    stroke="#246CC1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16 17H8"
                    stroke="#246CC1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10 9H8"
                    stroke="#246CC1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    margin: "0 0 6px 0",
                    color: "#246CC1",
                    fontSize: "16px",
                    fontWeight: "600",
                    fontFamily: "OggTextMedium",
                  }}
                >
                  National Finance Olympiad Registration
                </div>
                <div
                  style={{
                    margin: "0",
                    color: "#6B7280",
                    fontSize: "13px",
                    fontFamily: "OggTextRegular",
                  }}
                >
                  Exam Mode: Proctored Online (from your home)
                </div>
                <div
                  style={{
                    margin: "6px 0 0 0",
                    color: "#6B7280",
                    fontSize: "12px",
                    fontFamily: "OggTextRegular",
                    lineHeight: "1.2",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "3px",
                      fontWeight: "500",
                      fontSize: "12px",
                    }}
                  >
                    Available Exam Dates:
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(110px, 1fr))",
                      gap: "1px 4px",
                      fontSize: "12px",
                      color: "#8B9DC3",
                      lineHeight: "1.2",
                    }}
                  >
                    Participants can select the exam dates post registration.
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2: Preparation Material */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "12px 16px",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
                border: "1px solid rgba(36, 108, 193, 0.1)",
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "rgba(36, 108, 193, 0.1)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
                    stroke="#246CC1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.5 2H20V22H6.5A2.5 2.5 0 0 1 4 19.5V4.5A2.5 2.5 0 0 1 6.5 2Z"
                    stroke="#246CC1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 7H16"
                    stroke="#246CC1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 11H16"
                    stroke="#246CC1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 15H12"
                    stroke="#246CC1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    margin: "0 0 6px 0",
                    color: "#246CC1",
                    fontSize: "16px",
                    fontWeight: "600",
                    fontFamily: "OggTextMedium",
                  }}
                >
                  Olympiad Preparation Material
                </div>
                <div
                  style={{
                    color: "#6B7280",
                    fontSize: "13px",
                    fontFamily: "OggTextRegular",
                    lineHeight: "1.3",
                  }}
                >
                  <div style={{ marginBottom: "4px" }}>
                    • 1x - NFO Guidebook (E-Book)
                  </div>
                  <div>• 1x - Sample Question Paper</div>
                </div>
              </div>
            </div>

            {/* Card 3: Interactive Activities */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "12px 16px",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
                border: "1px solid rgba(36, 108, 193, 0.1)",
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "rgba(36, 108, 193, 0.1)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="2"
                    y="3"
                    width="20"
                    height="14"
                    rx="2"
                    ry="2"
                    stroke="#246CC1"
                    strokeWidth="2"
                  />
                  <line
                    x1="8"
                    y1="21"
                    x2="16"
                    y2="21"
                    stroke="#246CC1"
                    strokeWidth="2"
                  />
                  <line
                    x1="12"
                    y1="17"
                    x2="12"
                    y2="21"
                    stroke="#246CC1"
                    strokeWidth="2"
                  />
                  <circle cx="8" cy="8" r="1" fill="#246CC1" />
                  <circle cx="12" cy="8" r="1" fill="#246CC1" />
                  <circle cx="16" cy="8" r="1" fill="#246CC1" />
                  <circle cx="8" cy="12" r="1" fill="#246CC1" />
                  <circle cx="12" cy="12" r="1" fill="#246CC1" />
                  <circle cx="16" cy="12" r="1" fill="#246CC1" />
                </svg>
              </div>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    margin: "0 0 6px 0",
                    color: "#246CC1",
                    fontSize: "16px",
                    fontWeight: "600",
                    fontFamily: "OggTextMedium",
                  }}
                >
                  Interactive Digital Activities
                </div>
                <div
                  style={{
                    margin: "0",
                    color: "#6B7280",
                    fontSize: "13px",
                    fontFamily: "OggTextRegular",
                    lineHeight: "1.3",
                  }}
                >
                  The NFO Student Hub transforms important topics into
                  interactive activities, helping students apply what they
                  learn.
                </div>
              </div>
            </div>
          </div>
          {/* <div className="item-info-date-container">
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="item-info-date-title">Exam Date : </div>
              <div className="item-info-date-value">
                {formatDateTime(props.examDate).split(",")[0]}
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="item-info-date-title">Exam Time : </div>
              <div className="item-info-date-value">
                {formatDateTime(props.examDate).split(",")[1].trim()}
              </div>
            </div>
          </div> */}
          <div className="item-info-additembutton">
            <button
              className="item-info-overlap"
              onClick={() => {
                props.cbHandleCloseItemInfo();
                props.cbAddRecommended(props.currentItemId);
              }}
            >
              <div className="item-info-text-wrapper-7">Add to Cart</div>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ItemInfoModal;
